import HomeLayout from "../../commonComponents/HomeLayout";
import ContactUsFaqs from "./components/ContactUsFaqs";
import ContactUsHero from "./components/ContactUsHero";
import GetInTouch from "./components/GetInTouch";
import NextHomeSection from "./components/NextHomeSection";

const ContactUs = () => {
  return (
    <HomeLayout>
      <div className="">
        <div className="flex flex-col pt-8 gap-10 px-6 md:px-8 lg:px-16">
          <ContactUsHero />
          <GetInTouch />
          <ContactUsFaqs />
        </div>
        <NextHomeSection />
      </div>
    </HomeLayout>
  );
};

export default ContactUs;
